// Module
var code = "<svg fill=none xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 24\"><path d=\"M16.24 6.542C8.643 1.89-.015 9.977 7.038 18.782M18.16 16.881C22.364 9.028 12.5 0 5.407 8.402M7.18 18.986l-4.381-.819M7.353 18.98l1.389-4.333\" stroke-width=2 stroke-linecap=round /></svg> ";
// Exports
module.exports = code;